/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Coordinates } from './coordinates';


export interface BuildingBaseData { 
    name: string;
    sectionText?: string;
    externalNumber?: string;
    buildingType?: BuildingBaseData.BuildingTypeEnum;
    otherBuildingType?: string;
    buildingClass?: BuildingBaseData.BuildingClassEnum;
    otherBuildingClass?: string;
    area?: number;
    floorCountWithoutCellar?: string;
    coordinates?: Coordinates;
    uid?: string;
    insuranceNumber?: string;
    insuranceCompany?: BuildingBaseData.InsuranceCompanyEnum;
}
export namespace BuildingBaseData {
    export type BuildingTypeEnum = 'RESIDENTIAL_BUILDING' | 'RESIDENTIAL_BUILDING_WITH_BUSINESS' | 'SCHOOL' | 'OTHER';
    export const BuildingTypeEnum = {
        ResidentialBuilding: 'RESIDENTIAL_BUILDING' as BuildingTypeEnum,
        ResidentialBuildingWithBusiness: 'RESIDENTIAL_BUILDING_WITH_BUSINESS' as BuildingTypeEnum,
        School: 'SCHOOL' as BuildingTypeEnum,
        Other: 'OTHER' as BuildingTypeEnum
    };
    export type BuildingClassEnum = 'ONE' | 'TWO' | 'THREE' | 'FOUR' | 'FIVE' | 'TERRACED_HOUSES' | 'HIGHRISE' | 'OTHER';
    export const BuildingClassEnum = {
        One: 'ONE' as BuildingClassEnum,
        Two: 'TWO' as BuildingClassEnum,
        Three: 'THREE' as BuildingClassEnum,
        Four: 'FOUR' as BuildingClassEnum,
        Five: 'FIVE' as BuildingClassEnum,
        TerracedHouses: 'TERRACED_HOUSES' as BuildingClassEnum,
        Highrise: 'HIGHRISE' as BuildingClassEnum,
        Other: 'OTHER' as BuildingClassEnum
    };
    export type InsuranceCompanyEnum = 'GRAWE' | 'WIENER_STAEDTISCHE' | 'UNIQUA' | 'SCHINNER' | 'EKV' | 'PMC_PAUL_MAYER_CONCEPT' | 'OOE_INSURANCE' | 'HDI_INSURANCE' | 'DONAU_INSURANCE' | 'KLV';
    export const InsuranceCompanyEnum = {
        Grawe: 'GRAWE' as InsuranceCompanyEnum,
        WienerStaedtische: 'WIENER_STAEDTISCHE' as InsuranceCompanyEnum,
        Uniqua: 'UNIQUA' as InsuranceCompanyEnum,
        Schinner: 'SCHINNER' as InsuranceCompanyEnum,
        Ekv: 'EKV' as InsuranceCompanyEnum,
        PmcPaulMayerConcept: 'PMC_PAUL_MAYER_CONCEPT' as InsuranceCompanyEnum,
        OoeInsurance: 'OOE_INSURANCE' as InsuranceCompanyEnum,
        HdiInsurance: 'HDI_INSURANCE' as InsuranceCompanyEnum,
        DonauInsurance: 'DONAU_INSURANCE' as InsuranceCompanyEnum,
        Klv: 'KLV' as InsuranceCompanyEnum
    };
}


